import { useTheme } from '@rescui/ui-contexts';
import { createTextCn } from './create-text-cn.js';

var useTextStyles = function useTextStyles() {
  return createTextCn(useTheme());
};

export { useTextStyles };
